import React from 'react'
import XLSX from 'xlsx'
import Btn from '../Btn/Btn'

export default class ExcelModeloBuilderMultiSheet extends React.Component {
  // Props: { modelos, filename }
  // modelos: [{ wsName: 'NomePlanilha', colunas: [Array de Arrays] }]

  onBtnClick = () => {
    const { modelos, filename } = this.props
    const wb = XLSX.utils.book_new()

    modelos.forEach(({ wsName, colunas }) => {
      const ws = XLSX.utils.aoa_to_sheet(colunas)
      XLSX.utils.book_append_sheet(wb, ws, wsName)
    })

    XLSX.writeFile(wb, filename, { type: 'base64' })
  }

  render() {
    return <Btn onClick={this.onBtnClick}>Baixar Modelo</Btn>
  }
}
